module.exports = __webpack_public_path__ + "f8568ba7f024a0096b60228ee0beb801.png";